import { Badge } from '@radix-ui/themes';
import { RX } from 'enums/radix';

export const BadgeBoolean = (props: { value: boolean }) => {
  return (
    <Badge color={props.value ? RX.CLR.SUCCESS : RX.CLR.DANGER}>
      {props.value ? 'YES' : 'NO'}
    </Badge>
  );
};
